import {
  leaderboardClient,
  RunsAttributesQueryDTO,
} from '@neptune/shared/core-apis-leaderboard-domain';

import { KnownAttributes } from 'domain/experiment/attribute';

import { Entity } from '../entity-model';

import { filterArchived, mergeEntitiesByUUID } from './helpers';
import { ListForRunsConverter } from './list-for-runs-converter';
import { EntitiesLists } from './list-for-runs-model';

type Params = {
  projectIdentifier: string;
  runsIds?: Array<string>;
  experimentNames?: Array<string>;
  attributePathsFilter: RunsAttributesQueryDTO['attributePathsFilter'];
};

type Config = {
  filterArchived?: boolean;
  flattenEntities?: boolean;
};

type ConfigWithFlatten = Config & { flattenEntities: true };
type ConfigWithoutFlatten = Config & { flattenEntities?: false };

export async function listEntities(
  params: Params,
  config: ConfigWithFlatten,
): Promise<Array<Entity>>;
export async function listEntities(
  params: Params,
  config?: ConfigWithoutFlatten,
): Promise<EntitiesLists>;

export async function listEntities(
  params: Params,
  config: Config = {},
): Promise<EntitiesLists | Array<Entity>> {
  const { projectIdentifier, runsIds, experimentNames, attributePathsFilter } = params;
  const result = await leaderboardClient.getAttributesForRunsAndExperiments({
    attributeQuery: {
      attributePathsFilter: config.filterArchived
        ? [...attributePathsFilter, KnownAttributes.Archived]
        : attributePathsFilter,
      projectIdentifier,
      runsIds,
      experimentNames,
    },
  });

  let entities = ListForRunsConverter.runsAttributes.fromApiToDomain(result);

  if (config.filterArchived) {
    entities = filterArchived(entities);
  }

  if (config.flattenEntities) {
    return mergeEntitiesByUUID(entities);
  }

  return entities;
}
